import { render, staticRenderFns } from "./purchase-sale-inventory.vue?vue&type=template&id=e6e52e9e&"
import script from "./purchase-sale-inventory.vue?vue&type=script&lang=js&"
export * from "./purchase-sale-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports